/* eslint no-inline-comments: 0 */

const Lists = () => import( /* webpackChunkName: "group-broadcasts" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-broadcasts" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-broadcasts" */ `./edit.vue` );

export default {
	path: `broadcasts`,
	children: [
		{
			path: ``,
			name: `list-broadcasts`,
			component: Lists,
			meta: {
				title: `Broadcasts`
			}
		},
		{
			path: `new`,
			name: `add-broadcast`,
			component: Add,
			meta: {
				title: `Add Broadcast`
			}
		},
		{
			path: `:uuid`,
			name: `edit-broadcast`,
			component: Edit,
			meta: {
				title: `Edit Broadcast`
			}
		}
	]
};
